import NavigationCountBadge from "./NavigationCountBadge";

export default NavigationCountBadge;
